import { process_ppt } from "./process_ppt";
import { process_image } from "./process_image";
import {
  process_expand_content,
  process_extract_content,
} from "./process_content_optimize";
import { process_icon_layout } from "./process_icon_layout.js";
import { process_onepage_classic_canvas } from "./process_onepage_classic_canvas";
import { process_onepage_market_size } from "./process_onepage_market_size";
import { process_onepage_market_adoption } from "./process_onepage_market_adoption";
import { content_edit } from "./process_optimize";

export function process_addin(input) {
  if (input.taskType == null) {
    process_ppt(input);
  } else {
    switch (input.taskType.id) {
      case "task_bp_normal":
      case "task_bp_tan_methodology": {
        process_ppt(input);
        break;
      }
      case "task_one_page_classic_canvas": {
        process_onepage_classic_canvas(input);
        break;
      }
      case "task_one_page_market_size": {
        process_onepage_market_size(input);
        break;
      }
      case "task_one_page_market_adoption": {
        process_onepage_market_adoption(input);
        break;
      }
      case "task_generate_image":
      case "task_change_image" : {
        process_image(input);
        break;
      }
      case "task_expand_silde_content": {
        process_expand_content(input);
        break;
      }
      case "task_extract_slide_content": {
        process_extract_content(input);
        break;
      }
      case "task_generate_icon": {
        process_icon_layout(input);
        break;
      }
      case "optimize_menu_length":
      case "optimize_menu_style":{
        content_edit(input);
        break;
      }
    }
  }
}
